import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/** Active public terms only; the quote determines the signed-in payer's eligibility. */
export function useFacilityCampaigns(facilityId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.booking.publicCampaigns(facilityId ?? ""),
    queryFn: () => facilityApi.listPublicCampaigns(facilityId as string),
    enabled: Boolean(facilityId),
    retry: false,
  });
}
